import * as Accordion from './native'

export default Accordion